// Axios and config
import Axios from "axios"
import AxiosConfig from "src/utilities/AxiosConfig"

// Interfaces
import I_BaseAPIResponse from "src/common_interfaces/I_BaseAPIResponse"
import { I_ApprovalStatusCounts } from "src/components/approvals/interfaces"
import { I_VehicleIncidentsFilters } from "../interfaces"

// Constants and utilities
import approvalStatusCountBoilerplate from "src/components/approvals/constants/ApprovalStatusCountBoilerplate"
import snackBar from "src/utilities/snackBar/SnackBar"

/**
 * Fetches approval status counts for Samsara vehicle events.
 * All counts (e.g. Pending, Approved, Ignored, New) are returned
 * from a single endpoint and filtered using the given parameters.
 *
 * @param filters - Optional filters for location, zip, etc.
 * @returns A filtered list of status counts
 */
const getCountsForSwitchView = async (
  filters: I_VehicleIncidentsFilters = {}
): Promise<I_ApprovalStatusCounts[]> => {
  try {
    // Build query params for filtering
    const queryParams = new URLSearchParams({
      ...(filters.city ? { city: filters.city } : {}),
      ...(filters.stateCode ? { state: filters.stateCode } : {}),
      ...(filters.zipCode ? { zipCode: filters.zipCode } : {}),
      ...(filters.locationCode ? { locationCode: filters.locationCode } : {}),
      ...(filters.employeeId ? { employeeId: filters.employeeId.toString() } : {}),
      ...(filters.labels?.length ? { label: filters.labels.join(",") } : {}),
    })

    const response = await Axios.get<I_BaseAPIResponse<I_ApprovalStatusCounts[]>>(
      `${process.env.REACT_APP_API_URL}/api/samsara/statuscounts?${queryParams.toString()}`,
      AxiosConfig.configValue()
    )

    if (response.data.HasError) {
      snackBar({
        type: "error",
        text: "Failed to fetch safety event counts",
        timeout: 5000
      })
      return approvalStatusCountBoilerplate
    }

    return response.data.Data
  } catch (error) {
    console.error("Network or parsing error:", error)

    snackBar({
      type: "error",
      text: "Failed to fetch safety event counts",
      timeout: 5000
    })

    return approvalStatusCountBoilerplate
  }
}

export default getCountsForSwitchView
